import { empathyIcons } from "../../../mocks/home";

export default function EmpathySection() {
  return (
    <section className="w-full bg-background-100 py-12 md:py-20">
      <div className="w-full px-4 sm:px-6 lg:px-10">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-light text-foreground-950 mb-8">
            You Don&apos;t Have to Keep Struggling in Silence, On the Inside&hellip;
          </h2>

          <div className="space-y-5 mb-8 text-left">
            <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
              From the outside, your life may look successful.
            </p>
            <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
              You go to work.
            </p>
            <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
              You smile.
            </p>
            <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
              You keep everything together.
            </p>
            <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
              But behind closed doors, you may be secretly worrying about your relationship with alcohol.
            </p>
            <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed font-medium">
              You don&apos;t have to carry that burden alone anymore.
            </p>
            <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
              Serena&apos;s Quiet Recovery Space has been created for people who are secretly worried about their alcohol addiction and value their privacy.
            </p>
            <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed font-medium">
              Do you want to better understand your relationship with alcohol in a safe, supportive and discreet online environment?
            </p>
            <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
              Whether you&apos;re a professional, business owner, public figure, or simply someone who prefers to keep your journey private, this is a place where you can begin&mdash;without judgement or public meetings.
            </p>

            <div className="pt-3">
              <p className="font-body text-sm md:text-base text-foreground-950 font-medium mb-4">
                Inside my course, you&apos;ll discover:
              </p>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <span className="text-primary-600 mt-0.5 flex-shrink-0">
                    <i className="ri-check-line" />
                  </span>
                  <span className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
                    Private and discreet online learning with personalised 1:1 support
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-primary-600 mt-0.5 flex-shrink-0">
                    <i className="ri-check-line" />
                  </span>
                  <span className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
                    Understanding the root cause
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-primary-600 mt-0.5 flex-shrink-0">
                    <i className="ri-check-line" />
                  </span>
                  <span className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
                    The role of shame and awareness
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-primary-600 mt-0.5 flex-shrink-0">
                    <i className="ri-check-line" />
                  </span>
                  <span className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
                    Building awareness and interrupting patterns
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-primary-600 mt-0.5 flex-shrink-0">
                    <i className="ri-check-line" />
                  </span>
                  <span className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
                    Identifying and managing triggers
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-primary-600 mt-0.5 flex-shrink-0">
                    <i className="ri-check-line" />
                  </span>
                  <span className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
                    Rebuilding trust and creating structure
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-primary-600 mt-0.5 flex-shrink-0">
                    <i className="ri-check-line" />
                  </span>
                  <span className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
                    Moving forward
                  </span>
                </li>
              </ul>
            </div>

            <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
              I offer a free discovery call and a free PDF guide explaining your next steps.
            </p>

            <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed italic">
              Recovery doesn&apos;t have to start publicly. It just has to start.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10 stagger-children">
            {empathyIcons.map((item) => (
              <div key={item.label} className="flex flex-col items-center gap-3">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className={`${item.icon} text-2xl md:text-3xl`} />
                </div>
                <span className="font-body text-sm text-foreground-700 text-center leading-snug">
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}